import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../medieval-office-kit';

const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art, f } = ctx;

  // soot-warm floor runner anchoring the craft zone (clear of the south door gap)
  place(ctx, f.rug(art, 150, 110), 430, 300);

  // HERO: the forge on the north wall — second big warm pool (rendered separately, leave clear)
  // anvil just south of it, quench barrel beside the forge
  place(ctx, kit.forge(art), 430, 104);
  place(ctx, kit.anvil(art), 430, 176);
  place(ctx, kit.barrel(art), 372, 150);

  // weapon racks hugging the west + east walls, facing in
  place(ctx, kit.weaponRack(art), 326, 200);
  place(ctx, kit.weaponRack(art), 534, 200);

  // suit of armour standing watch in the south-west corner
  place(ctx, kit.suitOfArmour(art), 336, 346);

  // shared crafting bench with three stools at the seat anchors
  place(ctx, kit.feastTable(art, 86), 430, 300);
  place(ctx, kit.woodStool(art), 390, 300);
  place(ctx, kit.woodStool(art), 470, 300);
  place(ctx, kit.woodStool(art), 430, 340);

  // lighting: forge already glows — add two wall torches well clear of the door
  place(ctx, kit.wallTorch(art), 360, 408);
  place(ctx, kit.wallTorch(art), 534, 300);

  // a touch of green so no corner reads as cold stone
  place(ctx, f.plant(art, 'fern'), 520, 344);
};

export default decorate;
